export const CHATBOT_EVENTS = {
    CHATBOT_OPENED: 'chatbot_opened',
    CHATBOT_CLOSED: 'chatbot_closed',
    CHATBOT_READY: 'chatbot_ready',
} as const;

export interface ChatBotEvents  {
    [CHATBOT_EVENTS.CHATBOT_OPENED]: { id?: string };
    [CHATBOT_EVENTS.CHATBOT_CLOSED]: { id?: string };
    [CHATBOT_EVENTS.CHATBOT_READY]: undefined;
};
